import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-detail",
  "use": "icon-form-detail-usage",
  "viewBox": "0 0 198.4 198.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 198.4 198.4\" id=\"icon-form-detail\">\r\n<path d=\"M39.7,100.3c0,7.3,6,13.2,13.2,13.2c7.3,0,13.2-6,13.2-13.2c0-7.3-6-13.2-13.2-13.2C45.6,87.1,39.7,93,39.7,100.3\r\n\tL39.7,100.3z\" />\r\n<path d=\"M86,100.3c0,7.3,6,13.2,13.2,13.2c7.3,0,13.2-6,13.2-13.2l0,0c0-7.3-6-13.2-13.2-13.2C91.9,87.1,86,93,86,100.3L86,100.3z\" />\r\n<path d=\"M132.3,100.3c0,7.3,6,13.2,13.2,13.2c7.3,0,13.2-6,13.2-13.2l0,0c0-7.3-6-13.2-13.2-13.2S132.3,93,132.3,100.3L132.3,100.3z\r\n\t\" />\r\n<path d=\"M99.2,198.4C44.1,198.4,0,154.4,0,99.2S44.1,0,99.2,0s99.2,44.1,99.2,99.2S154.4,198.4,99.2,198.4z M99.2,12.1\r\n\tc-48.5,0-87.1,38.6-87.1,87.1s39.7,87.1,87.1,87.1s87.1-39.7,87.1-87.1S147.7,12.1,99.2,12.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/form/form-detail.svg
// module id = Idi9
// module chunks = 13